module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-lincoln.4b5a4bda.png";